import type { AnalyticsIdentityCommand, CaptureResult, CapturedEventInput } from './earlyEvents';
export enum ProviderType {
  SENSORS = 'sensors',
  FACEBOOK = 'facebook',
  GA4 = 'ga4',
  TIKTOK = 'tiktok',
  APPLOVIN = 'applovin',
  BING = 'bing',
  CRITEO = 'criteo',
  PEPPERJAM = 'pepperjam',
  SNAPCHAT = 'snapchat',
  SNAPCHAT_CONVERSION = 'snapchat_conversion',
  OPENAI = 'openai',
  TWITTER = 'twitter',
  EMARSYS = 'emarsys',
  ONETRUST = 'onetrust',
  IMPACT_RADIUS = 'impactradius',
  AWIN = 'awin',
  GOOGLE_TRANSLATE = 'google_translate',
  GOOGLE_BADGE = 'google_badge',
  RTB_HOUSE = 'rtb_house',
  AWS_WAF = 'aws_waf',
  CONSENT_MANAGER = 'consent_manager',
  SNOWPLOW = 'snowplow',
}

/**
 * 事件级 Provider 行为选项，不进入业务 properties。
 */
export interface TrackingEventOptions {
  /** 是否从 Snowplow 最终载荷中完全省略 pixel 字段。 */
  omitPixel?: boolean;
}

export interface TrackingEvent {
  eventName?: string; // 事件名称
  commandType?: string; // 命令类型，在GA4或者Facebook会用到
  properties?: any;
  options?: TrackingEventOptions;
  eventId?: string; // 统一的事件 ID，用于跨平台事件关联
}

export interface Provider {
  type: ProviderType;
  isEnabled: boolean;
  init: () => Promise<boolean>;
  track: (event: TrackingEvent) => void;
  isInitialized: () => boolean;
  /** 新ZV适配器按已捕获快照交接，不能重新读取页面身份。 */
  trackCaptured?: (input: CapturedEventInput) => CaptureResult | Promise<CaptureResult>;
  /** 神策真实ready身份，只用于相同epoch的延后绑定。 */
  getIdentity?: () => { anonymousId?: string; distinctId?: string };
  /** 身份命令在事件序列中执行。 */
  applyIdentity?: (command: AnalyticsIdentityCommand) => boolean | Promise<boolean>;
}
